/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

// Modules import down here
import StoreNotifications from '@/stores/modules/StoreNotifications'
import StoreLoading from '@/stores/modules/StoreLoading'

// Initialize vuex
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    // Include imported modules in here
    StoreNotifications,
    StoreLoading
  },
  strict: debug
})
